import { useTranslation } from 'react-i18next'
import { SearchInput } from '../../../../../components'

const ProductSearch = ({
  alertMsg,
  search,
  inputRef,
  onSearchChange = value => {},
  dependencies,
  fullWidth = false,
  disabled = false,
  acceptsUnitCode = false,
}) => {
  const { i18n } = useTranslation()

  return (
    // `fullWidth` lets the parent stretch the input to its container width
    // (used by the new packing-context wrapper in ProductListHeader); legacy
    // callers keep the original `w-2/5` constraint.
    <div className={`flex flex-col justify-center ${fullWidth ? 'w-full' : 'w-2/5'}`}>
      <SearchInput
        inputValue={search}
        selectedInitial={search}
        placeholder={i18n.t(
          acceptsUnitCode
            ? 'generate_shipment.product_list.product_search.placeholder_with_unit_code'
            : 'generate_shipment.product_list.product_search.placeholder',
        )}
        hideIcons={true}
        ref={inputRef}
        debounce={250}
        onChange={onSearchChange}
        onPaste={e => {
          e.preventDefault()
        }}
        dependencies={[dependencies]}
        disabledSearchOnChange={true}
        disabled={disabled}
      />

      {alertMsg && <p className="mt-1 text-sm text-red-600">{alertMsg}</p>}
    </div>
  )
}

export default ProductSearch
